import React, { createContext, useState } from "react";
import { Log } from "../utils/genericUtils";

const AlertContext = createContext();

function AlertProvider({ children }) {
  const [alertState, setAlertState] = useState({
    isActive: false,
    type: "success | error | info | warning",
    header: "header",
    message: "message",
    buttonText: "Ok",
    onAcknowledge: () => {},
    index: 0,
  });

  const globalAlert = (type = "info", header = "alert", message = "", onAcknowledge = () => {}, buttonText = "") => {
    Log("global alert called: ", { isActive: true, type, header, message, onAcknowledge, buttonText });
    setAlertState({ isActive: true, type, header, message, onAcknowledge, buttonText, index: alertState.index + 1 });
  };

  return <AlertContext.Provider value={{ alertState, globalAlert }}>{children}</AlertContext.Provider>;
}

export { AlertContext, AlertProvider };
